import baseConfig from '../../../baseConfig/pg/v2/paymentForms';

export default baseConfig;
